import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
import commonFrame from './components/common'

Vue.use(Router)
if (localStorage.getItem('res')) {
  let res = JSON.parse(localStorage.getItem('res'))
  let config = JSON.parse(localStorage.getItem('config'))
  let routers = JSON.parse(localStorage.getItem('routers'));
  let province = JSON.parse(localStorage.getItem('province'));
  store.commit('saveConfig',config)
  store.commit('saveLoginInfo', res)
  store.commit('saveRouters',routers)
  store.commit('saveProvince',province)
}else{
  localStorage.clear()
  // location.href = window.location.origin + window.location.pathname 
}

let route = [
    {
      path: '/',
      name: 'login',
      component: () => import('@/views/login/login'), 
      hidden:true,
    },
    {
      path: '/index',
      name: '首页',
      component: commonFrame,
      icon:require('./assets/image/home_icon.png'),
      children:[
        {
          path: '',
          component: () => import('@/views/index/index'),
          name: '首页',
          meta: { title: '首页',hidden:false,}
        },]
    },
    {
      path: '/user',
      name: '个人中心',
      component: commonFrame,
      redirect: '/user/user',
      meta: { title: '个人中心',roles: [1,2,3,4,5,6,8]},
      children:[
        {
          path: 'user',
          component: () => import('@/views/user/userCenter'),
          name: '个人中心',
          meta: { title: '个人中心',hidden:false,}
        },
        {
          path: 'changePassword',
          component: () => import('@/views/user/changePassword'),
          name: '修改密码',
          meta: { title: '修改密码',hidden:false,}
        },
      ]
    },
    {
      path: '/rotation',
      name: '基础管理',
      component: commonFrame,
      redirect: '/rotation/rotation',
      icon:require('./assets/image/base_icon.png'),
      meta: { title: '基础管理',roles: [1,2,3,4]},
      children:[
        {
          path: 'rotation',
          component: () => import('@/views/rotation/rotation'),
          name: '轮播图管理',
          meta: { title: '轮播图管理',hidden:false,},
        },
        {
          path: 'addRotation',
          component: () => import('@/views/rotation/addRotation'),
          name: '添加轮播图',
          meta: { 
            title: '添加轮播图',hidden:true,
            parent:[
              {
                path: 'rotation',
                component: () => import('@/views/rotation/rotation'),
                name: '轮播图管理',
                redirect: '/rotation/rotation',
                meta: { title: '轮播图管理',hidden:false,},
              },
            ]
          }
        },
        {
          path: 'editRotation/:id(\\d+)',
          component: () => import('@/views/rotation/editRotation'),
          name: '编辑轮播图',
          meta: { 
            title: '编辑轮播图',hidden:true,
            parent:[
              {
                path: 'rotation',
                component: () => import('@/views/rotation/rotation'),
                name: '轮播图管理',
                redirect: '/rotation/rotation',
                meta: { title: '轮播图管理',hidden:false,},
              },
            ]
          }
        },
        {
          path: 'information',
          component: () => import('@/views/information/information'),
          name: '资讯列表',
          meta: { title: '资讯列表',hidden:false,},
        },
        {
          path: 'addInformation',
          component: () => import('@/views/information/addInformation'),
          name: '添加资讯',
          meta: { 
            title: '添加资讯',hidden:true,
            parent:[
              {
                path: 'information',
                component: () => import('@/views/information/information'),
                name: '资讯列表',
                redirect: '/rotation/information',
                meta: { title: '资讯列表',hidden:false,},
              },
            ]
          }
        },
        {
          path: 'editInformation/:id(\\d+)',
          component: () => import('@/views/information/editInformation'),
          name: '编辑资讯',
          meta: { 
            title: '编辑资讯',hidden:true,
            parent:[
              {
                path: 'information',
                component: () => import('@/views/information/information'),
                name: '资讯列表',
                redirect: '/rotation/information',
                meta: { title: '资讯列表',hidden:false,},
              },
            ]
          }
        },
        
      ]
    },
    {
      path: '/organization',
      name: '组织机构',
      component: commonFrame,
      redirect: '/organization/organization',
      icon:require('./assets/image/jigou_icon.png'),
      meta: { title: '组织机构',roles: [1,2,3,4]},
      children:[
        {
          path: 'organization',
          component: () => import('@/views/organization/organization'),
          name: '机构列表',
          meta: { title: '机构列表',hidden:false,}
        },
        {
          path: 'addOrganization',
          component: () => import('@/views/organization/addOrganization'),
          name: '添加机构',
          meta: { title: '添加机构',hidden:true,}
        },
        {
          path: 'editOrganization/:id(\\d+)',
          component: () => import('@/views/organization/editOrganization'),
          name: '机构编辑',
          meta: { title: '机构编辑',hidden:true,}
        },
        {
          path: 'detailOrganization/:id(\\d+)',
          component: () => import('@/views/organization/detailOrganization'),
          name: '机构详情',
          meta: { title: '机构详情',hidden:true,}
        },
      ]
    },
    {
      path: '/period',
      name: '期次管理',
      component: commonFrame,
      redirect: '/period/period',
      icon:require('./assets/image/zhujiao_icon.png'),
      meta: { title: '期次管理',roles: [1,2,3,4,5,8]},
      children:[
        {
          path: 'period',
          component: () => import('@/views/period/period'),
          name: '期次列表',
          meta: { title: '期次列表',hidden:false,}
        },
        {
          path: 'addPeriod',
          component: () => import('@/views/period/addPeriod'),
          name: '添加期次',
          meta: { title: '添加期次',hidden:true,}
        },
        {
          path: 'editPeriod/:id(\\d+)',
          component: () => import('@/views/period/editPeriod'),
          name: '编辑期次',
          meta: { title: '编辑期次',hidden:true,}
        },
        {
          path: 'periodStudent/:id(\\d+)',
          component: () => import('@/views/period/student/periodStudent'),
          name: '学员列表',
          meta: { title: '学员列表',hidden:true,}
        },
        {
          path: 'addPeriodStudent/:id(\\d+)',
          component: () => import('@/views/period/student/addPeriodStudent'),
          name: '添加学员',
          meta: { 
            title: '添加学员',hidden:true,
            parent:[
              {
                path: 'periodStudent/:id(\\d+)',
                component: () => import('@/views/period/student/periodStudent'),
                name: '学员列表',
                meta: { title: '学员列表',hidden:false,},
              },
            ]
          }
        },
        {
          path: 'editPeriodStudent/:id(\\d+)',
          component: () => import('@/views/period/student/editPeriodStudent'),
          name: '编辑学员',
          meta: {
            title: '编辑学员',hidden:true,
            parent:[
              {
                path: 'periodStudent/:id(\\d+)',
                component: () => import('@/views/period/student/periodStudent'),
                name: '学员列表',
                meta: { title: '学员列表',hidden:false,},
              },
            ]
          }
        },
        {
          path: 'entranceForm/:id(\\d+)',
          component: () => import('@/views/period/student/entranceForm'),
          name: '学员入学登记表审核',
          meta: { 
            title: '学员入学登记表审核',hidden:true,
            parent:[
              {
                path: 'periodStudent/:id(\\d+)',
                component: () => import('@/views/period/student/periodStudent'),
                name: '学员列表',
                meta: { title: '学员列表',hidden:false,},
              },
            ]
          }
        },
      ]
    },
    {
      path: '/class', //班级管理
      name: '班级管理',
      component: commonFrame,
      redirect: '/class/class',
      icon:require('./assets/image/class_icon.png'),
      meta: { title: '班级管理',roles: [1,2,3,4,5,6,8]},
      children:[
        {
          path: 'class',
          component: () => import('@/views/class/class'),
          name: '班级列表',
          meta: { title: '班级列表',hidden:false,}
        },
        {
          path: 'addClass',
          component: () => import('@/views/class/addClass'),
          name: '添加班级',
          meta: { title: '添加班级',hidden:true,}
        },
        {
          path: 'editClass/:id(\\d+)',
          component: () => import('@/views/class/editClass'),
          name: '编辑班级',
          meta: { title: '编辑班级',hidden:true,}
        },
        
        {
          path: 'student/:id(\\d+)',
            component: () => import('@/views/class/student/student'),
            name: '学员列表',
            meta: { title: '学员列表',hidden:true,}
        },
        {
          path: 'addStudent/:id(\\d+)',
          component: () => import('@/views/class/student/addStudent'),
          name: '添加学员',
          meta: { 
            title: '添加学员',hidden:true,
            parent:[
              {
                path: 'student/:id(\\d+)',
                component: () => import('@/views/class/student/student'),
                name: '学员列表',
                meta: { title: '学员列表',hidden:true,}
              },
            ]
          }
        },
        {
          path: 'editStudent/:id(\\d+)',
          component: () => import('@/views/class/student/editStudent'),
          name: '编辑学员',
          meta: { 
            title: '编辑学员',hidden:true,
            parent:[
              {
                path: 'student/:id(\\d+)',
                component: () => import('@/views/class/student/student'),
                name: '学员列表',
                meta: { title: '学员列表',hidden:true,}
              },
            ]
          }
        },
        {
          path: 'course/:id(\\d+)',
          component: () => import('@/views/class/course/course'),
          name: '课程列表',
          meta: { 
            title: '课程列表',hidden:true,
          }
        },
        {
          path: 'relationClass/:id(\\d+)',
          component: () => import('@/views/class/course/relationClass'),
          name: '关联课程',
          meta: { 
            title: '关联课程',hidden:true,
            parent:[
              {
                path: 'course/:id(\\d+)',
                component: () => import('@/views/class/course/course'),
                name: '课程列表',
                meta: { title: '课程列表',hidden:true,}
                }
            ]
          }
        },
        {
          path: 'relationEdit/:id(\\d+)',
          component: () => import('@/views/class/course/relationEdit'),
          name: '关联课程详情',
          meta: { 
            title: '关联课程详情',hidden:true,
            parent:[
              {
                path: 'course/:id(\\d+)',
                component: () => import('@/views/class/course/course'),
                name: '课程列表',
                meta: { title: '课程列表',hidden:true,}
                }
            ]
          }
        },
      ]
    },
    {
      path: '/lecturer', //轮播图
      name: '讲师管理',
      component: commonFrame,
      redirect: '/lecturer/lecturer',
      icon:require('./assets/image/teacher_icon.png'),
      meta: { title: '讲师管理',roles: [1,2,3,4,5]},
      children:[
        {
          path: 'lecturer',
          component: () => import('@/views/lecturer/lecturer'),
          name: '讲师列表',
          meta: { title: '讲师列表',hidden:false,}
        },
        {
          path: 'addLecturer',
          component: () => import('@/views/lecturer/addLecturer'),
          name: '添加讲师',
          meta: { title: '添加讲师',hidden:true,}
        },
        {
          path: 'editLecturer/:id(\\d+)',
          component: () => import('@/views/lecturer/editLecturer'),
          name: '编辑讲师',
          meta: { title: '编辑讲师',hidden:true,}
        },
      ]
    },
    {
      path: '/assistant', //轮播图
      name: '助教管理',
      component: commonFrame,
      redirect: '/assistant/assistant',
      icon:require('./assets/image/zhujiao_icon.png'),
      meta: { title: '助教管理',roles: [1,2,3,4,5]},
      children:[
        {
          path: 'assistant',
          component: () => import('@/views/assistant/assistant'),
          name: '助教列表',
          meta: { title: '助教列表',hidden:false,}
        },
        {
          path: 'addAssistant',
          component: () => import('@/views/assistant/addAssistant'),
          name: '添加助教',
          meta: { title: '添加助教',hidden:true,}
        },
        {
          path: 'editAssistant/:id(\\d+)',
          component: () => import('@/views/assistant/editAssistant'),
          name: '编辑助教',
          meta: { title: '编辑助教',hidden:true,}
        },
      ]
    },
    {
      path: '/student', //轮播图
      name: '学员管理',
      component: commonFrame,
      redirect: '/student/enrollmentForm',
      icon:require('./assets/image/student_icon.png'),
      meta: { title: '学员管理',roles: [1,2,3,4,5,6,8]},
      children:[
        {
          path: 'basicsStudent',
          component: () => import('@/views/studentManage/basicsStudent'),
          name: '学员列表',
          meta: { title: '学员列表',hidden:false,}
        },
        {
          path: 'enrollmentForm',
          component: () => import('@/views/studentManage/enrollmentForm'),
          name: '入学登记表',
          meta: { title: '入学登记表',hidden:false,}
        },
        {
          path: 'agreement',
          component: () => import('@/views/studentManage/agreement'),
          name: '协议书',
          meta: { title: '协议书',hidden:false,}
        },
        {
          path: 'progress',
          component: () => import('@/views/studentManage/progress'),
          name: '学习进度',
          meta: { title: '学习进度',hidden:false,}
        },
        {
          path: 'videoCheck',
          component: () => import('@/views/studentManage/videoCheck'),
          name: '视频签到',
          meta: { title: '视频签到',hidden:false,}
        },
        {
          path: 'learningRecord',
          component: () => import('@/views/studentManage/learningRecord'),
          name: '学习记录',
          meta: { title: '学习记录',hidden:false,}
        },
        {
          path: 'feedback',
          component: () => import('@/views/studentManage/feedback'),
          name: '意见反馈',
          meta: { title: '意见反馈',hidden:false,}
        },
        {
          path: 'feedbackDetail/:id(\\d+)',
          component: () => import('@/views/studentManage/feedbackDetail'),
          name: '意见反馈详情',
          meta: { title: '意见反馈详情',hidden:true,}
        },
        {
          path: 'ideaAnalysis',
          component: () => import('@/views/studentManage/ideaAnalysis'),
          name: '想法分析书',
          meta: { title: '想法分析书',hidden:false,}
        },
        {
          path: 'ideaAnalysisDetail/:id(\\d+)',
          component: () => import('@/views/studentManage/ideaAnalysisDetail'),
          name: '想法分析书详情',
          meta: { title: '想法分析书详情',hidden:true,}
        },
        {
          path: 'prospectus',
          component: () => import('@/views/studentManage/prospectus'),
          name: '创业计划书',
          meta: { title: '创业计划书',hidden:false,}
        },
        {
          path: 'finalEvaluation',
          component: () => import('@/views/studentManage/finalEvaluation'),
          name: '期末评估表',
          meta: { title: '期末评估表',hidden:false,}
        },
        {
          path: 'finalEvaluationDetail/:id(\\d+)',
          component: () => import('@/views/studentManage/finalEvaluationDetail'),
          name: '期末评估表详情',
          meta: { title: '期末评估表详情',hidden:true,}
        },
        {
          path: 'prospectusDetail/:id(\\d+)',
          component: () => import('@/views/studentManage/prospectusDetail'),
          name: '创业评估表详情',
          meta: { title: '创业评估表详情',hidden:true,}
        },
        {
          path: 'test',
          component: () => import('@/views/studentManage/test'),
          name: '考试管理',
          meta: { title: '考试管理',hidden:false,}
        },
        {
          path: 'testDetail/:id(\\d+)',
          component: () => import('@/views/studentManage/testDetail'),
          name: '考试详情',
          meta: { 
            title: '考试详情',hidden:true,
            parent:[
              {
                path: 'test',
                component: () => import('@/views/studentManage/test'),
                name: '考试管理',
                meta: { title: '考试管理',hidden:false,}
              },
            ]
          }
        },
        {
          path: 'testMarkingPapers/:id(\\d+)',
          component: () => import('@/views/studentManage/testMarkingPapers'),
          name: '阅卷',
          meta: { 
            title: '阅卷',hidden:true,
            parent:[
              {
                path: 'test',
                component: () => import('@/views/studentManage/test'),
                name: '考试管理',
                meta: { title: '考试管理',hidden:false,}
              },
            ]
          }
        },
      ]
    },
    {
      path: '/exam', //
      name: '试卷管理',
      component: commonFrame,
      redirect: '/exam/exam',
      icon:require('./assets/image/kaoshi_icon.png'),
      meta: { title: '试卷管理',roles: [1,2,3,4]},
      children:[
        {
          path: 'exam',
          component: () => import('@/views/exam/exam'),
          name: '试卷列表',
          meta: { title: '试卷列表',hidden:false,}
        },
        {
          path: 'addExam',
          component: () => import('@/views/exam/addExam'),
          name: '添加试卷',
          meta: { 
            title: '添加试卷',hidden:true,
            parent:[
              {
                path: 'exam',
                component: () => import('@/views/exam/exam'),
                name: '试卷列表',
                meta: { title: '试卷列表',hidden:false,}
              },
            ]
          }
        },
        {
          path: 'editExam/:id(\\d+)',
          component: () => import('@/views/exam/editExam'),
          name: '编辑试卷',
          meta: { 
            title: '编辑试卷',hidden:true,
            parent:[
              {
                path: 'exam',
                component: () => import('@/views/exam/exam'),
                name: '试卷列表',
                meta: { title: '试卷列表',hidden:false,}
              },
            ]
          }
        },
        {
          path: 'subject',
          component: () => import('@/views/exam/subject/subject'),
          name: '题目列表',
          meta: { 
            title: '题目列表',hidden:false,
            parent:[
              {
                path: 'subject',
                component: () => import('@/views/exam/subject/subject'),
                name: '题目列表',
                meta: { title: '题目列表',hidden:false,}
              }  
            ]
          }
        },
        {
          path: 'addSubject',
          component: () => import('@/views/exam/subject/addSubject'),
          name: '添加题目',
          meta: { 
            title: '添加题目',hidden:true,
            parent:[
              {
                path: 'subject',
                component: () => import('@/views/exam/subject/subject'),
                name: '题目列表',
                meta: { title: '题目列表',hidden:false,}
              }  
            ]
          }
        },
        {
          path: 'editSubject/:id(\\d+)',
          component: () => import('@/views/exam/subject/editSubject'),
          name: '编辑题目',
          meta: { 
            title: '编辑题目',hidden:true,
            parent:[
              {
                path: 'subject',
                component: () => import('@/views/exam/subject/subject'),
                name: '题目列表',
                meta: { title: '题目列表',hidden:false,}
              }  
            ]
          }
        },
      ]
    },
    {
      path: '/task', //
      name: '作业管理',
      component: commonFrame,
      redirect: '/task/task',
      icon:require('./assets/image/task_icon.png'),
      meta: { title: '作业管理',roles: [1,2,3,4]},
      children:[
        {
          path: 'task',
          component: () => import('@/views/task/task'),
          name: '作业列表',
          meta: { title: '作业列表',hidden:false,}
        },
        {
          path: 'addTask',
          component: () => import('@/views/task/addTask'),
          name: '添加作业',
          meta: {
             title: '添加作业',hidden:true,
            parent:[
              {
                path: 'task',
                component: () => import('@/views/task/task'),
                name: '作业列表',
                meta: { title: '作业列表',hidden:false,}
              },
            ]  
          }
        },
        {   
          path: 'editTask/:id(\\d+)',
          component: () => import('@/views/task/editTask'),
          name: '编辑作业',
          meta: {
             title: '编辑作业',hidden:true,
            parent:[
              {
                path: 'task',
                component: () => import('@/views/task/task'),
                name: '作业列表',
                meta: { title: '作业列表',hidden:false,}
              },
            ]  
          }
        },
        {
          path: 'detailTask/:id(\\d+)',
          component: () => import('@/views/task/detailTask'),
          name: '作业详情',
          meta: {
             title: '作业详情',hidden:true,
            parent:[
              {
                path: 'task',
                component: () => import('@/views/task/task'),
                name: '作业列表',
                meta: { title: '作业列表',hidden:false,}
              },
            ]  
          }
        },
        {
          path: 'taskSubject',
          component: () => import('@/views/task/taskSubject/taskSubject'),
          name: '题目列表',
          meta: { title: '题目列表',hidden:false,}
        },
        {
          path: 'addTaskSubject',
          component: () => import('@/views/task/taskSubject/addTaskSubject'),
          name: '添加题目',
          meta: { 
            title: '添加题目',hidden:true,
            parent:[
              {
                path: 'taskSubject',
                component: () => import('@/views/task/taskSubject/taskSubject'),
                name: '题目列表',
                meta: { title: '题目列表',hidden:false,}
              },
            ]
          }
        },
        {
          path: 'editTaskSubject/:id(\\d+)',
          component: () => import('@/views/task/taskSubject/editTaskSubject'),
          name: '编辑题目',
          meta: { 
            title: '编辑题目',hidden:true,
            parent:[
              {
                path: 'taskSubject',
                component: () => import('@/views/task/taskSubject/taskSubject'),
                name: '题目列表',
                meta: { title: '题目列表',hidden:false,}
              },
            ]
          }
        },
      ]
    },
    // {
    //   path: '/certificate', //证书管理
    //   name: '证书管理',
    //   component: commonFrame,
    //   redirect: '/certificate/certificate',
    //   icon:require('./assets/image/zhengshu_icon.png'),
    //   meta: { title: '证书管理'},
    //   children:[
    //     {
    //       path: 'certificate',
    //       component: () => import('@/views/certificate/certificate'),
    //       name: '证书管理',
    //       meta: { title: '证书管理',hidden:false,}
    //     },
    //   ]
    // },
    {
      path: '/system', //
      name: '系统设置',
      component: commonFrame,
      redirect: '/system/supervise',
      icon:require('./assets/image/shezhi_icon.png'),
      meta: { title: '系统设置',roles: [1,2,3,4]},
      children:[
        {
          path: 'supervise',
          component: () => import('@/views/system/supervise/supervise'),
          name: '监管设置',
          meta: { title: '监管设置',hidden:false,}
        },
        {
          path: 'supervise/addSupervise',
          component: () => import('@/views/system/supervise/addSupervise'),
          name: '添加监管',
          meta: { title: '添加监管',hidden:true,}
        },
        {
          path: 'supervise/editSupervise',
          component: () => import('@/views/system/supervise/editSupervise'),
          name: '监管编辑',
          meta: { title: '监管编辑',hidden:true,}
        },
      ]
    },
  ];
  // 

// if(store.state.routers){
//   let routerArr = JSON.parse(store.state.routers)
//   routerArr.forEach(function(v,k){
//     v.component = new Object()
//     v.component = commonFrame
//     let ic = require('./assets/'+ v.icon.split("''"))
//     let arr = []
//     arr = v.children
//     if(arr.length>0){
//       arr.forEach(function(n,m){
//         let c = n.component.split("''")
//         let url = import('@/views/'+c)
//         n.component = ()=>url
//         n.meta.hidden = false
//         if(n.hidden){
//           n.meta.hidden = true
//         }
//       })
//     }
//     v.icon = ic
//     route.push(v)
//   });
// }
export default new Router({
  // mode: 'history', 
	routes: route
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

